import { RadioButtonWithLabelOption } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../../codegen/Localize';
import { FormikRadioButtonGroup } from '../../../../../commonInfra/components/FormikRadioButtonGroup';
import { FeatureFlags } from '../../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { PersonalSpaceEnabledOption } from './PersonalSpaceEnabledOption';

export const PERSONAL_SPACE_FIELD = 'settings.sitePersonalSpaceSettings.personalSpaceEnabled';

export type PersonalSpaceSectionProps = SiteSettingsForSiteAdminProps<'sitePersonalSpaceSettings'>;

function getButtonsList(props: PersonalSpaceSectionProps): RadioButtonWithLabelOption<boolean>[] {
  return [
    {
      value: true,
      label: <PersonalSpaceEnabledOption {...props} />,
      testId: 'personal-space-enabled-radio-button'
    },
    {
      value: false,
      label: getPSDisabledOption(),
      testId: 'personal-space-disabled-radio-button'
    }
  ];
}

function getPSDisabledOption() {
  return <>
      <div>{Messages.personalSpaceSiteSettingDisabled()}</div>
      <div>{Messages.personalSpaceSiteSettingDisabledDescription()}</div>
    </>;
}

export function PersonalSpaceSection(props: PersonalSpaceSectionProps) {
  const buttons = React.useMemo(() => getButtonsList(props), [props]);

  if(!FeatureFlags.personalSpaceEnabled) {
    return null;
  }

  return (
    <SettingsSection title={Messages.personalSpaceSiteSetting()}
      description={Messages.personalSpaceSiteSettingDescription()}>

      <FormikRadioButtonGroup
        buttonList={buttons}
        className={settingsRadioButtonItemHeight}
        name={PERSONAL_SPACE_FIELD}
        aria-label={Messages.personalSpaceSiteSettingDescription()}
      />
    </SettingsSection>
  );
}

export const PersonalSpaceSectionSpecs = componentRegistryEntry({
  name: 'PersonalSpaceSection',
  component: PersonalSpaceSection
});

